templates = require 'views/internal/templates'
View = require 'view'

module.exports = class SelectMemberView extends View
  # options: showUnconfirmed, showInactive, linkName
  initialize: ->

  render: ->
    data = @model.toJSON()

    if @model.get('memberType') == "ghost"
      data.isVirtual = true

    data.unconfirmed = @options.showUnconfirmed && !data.isVirtual && !data.confirmed
    data.inactive = @options.showInactive && !data.active

    data.isKnownMember = @options.isKnownMember
    data.extraText = @options.extraText
    data.disabled = @options.disabled

    if @options.linkName
      data.url = "/#{@model.get('username')}"
    else
      delete data.url

    @$el[0].innerHTML = templates.fill(
      'select_member',
      data,
      {},
      member: templates.member
    )

    @$('.js-member').data('id', @model.id)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/member/select-member-view.coffee